// 004 (research R6): place search / reverse geocoding port. Only `none` exists now (search hidden,
// fields typed by the parent); a Google geocoder comes with the Google provider.
import type { MapConfig } from "../../config/validate";
import type { Geocoder } from "./types";

export function createGeocoder(kind: MapConfig["geocoder"]): Geocoder {
  switch (kind) {
    case "none":
      return null;
  }
}
